import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PriceListService', PriceListService);

  PriceListService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    'UtilService',
    'SessionService',
    'PriceListModalService',
    'ModalWindowConfirmService',
    'TranslationModalService',
  ];

  function PriceListService(
    RestResource,
    config,
    $translate,
    UtilService,
    SessionService,
    PriceListModalService,
    ModalWindowConfirmService,
    TranslationModalService
  ) {
    let utils = new UtilService(this);

    let apiUrl = environment.apiEndpoint + 'price_lists';

    let service = {
      getFilterCriteria: getFilterCriteria,
      getPriceLists: getPriceLists,
      getPriceList: getPriceList,
      savePriceList: savePriceList,
      changePriceListStatus: changePriceListStatus,
      deleletePriceList: deleletePriceList,
      changePriceListDefault: changePriceListDefault,
      openPriceListTranslations: openPriceListTranslations,
      openPriceListsModal: openPriceListsModal,
      openPriceListDetail: openPriceListDetail,
      selectDefaultPriceList: selectDefaultPriceList,
      changePriceListIncludeTaxes: changePriceListIncludeTaxes,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      let filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'predefined',
      };

      return filterCriteria;
    }

    function getPriceLists(filterCriteria, companyId) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = companyId || SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getPriceList(id, language) {
      var params = { lang: null };

      if (language) {
        params = {
          lang: language,
        };
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePriceList(item, language) {
      let method;
      let url = apiUrl;

      if (!item.id) {
        // create
        method = 'post';
      } else {
        method = 'put';
        url = url + '/' + item.id;
      }

      let lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        let msg = !item.id ? 'NEW_ADDED_PRICE_LIST' : 'MODIFIED_PRICE_LIST';
        utils._successMsg($translate.instant(msg));

        if (!item.id) {
          // Create
          utils._setFlashMessage($translate.instant('PRICE_LIST_ADDED_MSG'));
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        // console.log(response.data.errors);
        // if (response.data.errors) {
        //   utils.openModalError(response.data.errors);
        // }

        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { price_list: item, lang: lang }, success, failure);
    }

    function changePriceListStatus(item) {
      let url = apiUrl + '/' + item.id;

      let params = { title: '', successMsg: '' };
      if (item.status === config.ACTIVE) {
        params.title = 'SURE_TO_DEACTIVATE_PRICE_LIST';
        // params.body = 'DEACTIVATING_PRICE_LIST_WARNING';
        params.successMsg = 'MODIFIED_PRICE_LIST';
      }

      utils.changeItemStatus(url, item, params);
    }

    function deleletePriceList(id, successCallback) {
      let url = apiUrl + '/' + id;

      let params = {
        title: 'SURE_TO_DELETE_PRICE_LIST',
        // body: 'DELETING_PRICE_LIST_WARNING',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'DELETED_PRICE_LIST',
      };

      utils.deleteItem(url, successCallback, params, {});
    }

    function changePriceListDefault(item, getItemsCallback) {
      let url = apiUrl + '/' + item.id;

      item.is_default = true;

      let params = {
        price_list: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        let msg = $translate.instant('DEFAULT_PRICE_LIST_CHANGED');
        utils._successMsg(msg);

        return getItemsCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function openPriceListTranslations(item, additionalLanguages) {
      let template = './app/ajs/price-lists/modals/price-lists-detail-translation.html';

      let modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      let initializeCallback = function (itemId, language) {
        return getPriceList(itemId, language).then(function (data) {
          return data;
        });
      };

      let confirmCallback = function (item, language) {
        return savePriceList(item, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function openPriceListsModal(getItemsCallback) {
      PriceListModalService.openPriceLists(getItemsCallback);
    }

    function openPriceListDetail(itemId, successCallback) {
      PriceListModalService.openPriceListDetail(itemId, successCallback);
    }

    function selectDefaultPriceList(priceLists) {
      for (let i = 0; i < priceLists.length; i++) {
        if (priceLists[i].is_default) {
          return priceLists[i];
        }
      }
    }

    function changePriceListIncludeTaxes(successCallback, params, cancelCallback) {
      let modalParams = {
        mode: params.mode ? params.mode : 'danger',
        title: params.title ? params.title : 'SURE_TO_DEACTIVATE_INCLUDED_TAXES',
        body: params.body ? params.body : '',
      };

      ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
    }
  }
})();
